import React from 'react';

interface FilterListButtonProps {
    onClick: () => void;
    hasFiltersApplied?: boolean;
}

const FilterListButton: React.FC<FilterListButtonProps> = ({ onClick, hasFiltersApplied = false }) => (
    <button
        type="button"
        className="btn btn-sm btn-light me-2 position-relative"
        onClick={onClick}
    >
        <span className="indicator-label">
            Filter List
        </span>
        {hasFiltersApplied && (
            <span
                className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                style={{ fontSize: '0.7em', padding: '0.3em 0.5em' }}
                title="Filters applied"
            >
                ●
            </span>
        )}
    </button>
);

export default FilterListButton;